import { render, staticRenderFns } from "./shopMenu.vue?vue&type=template&id=43cc0fb4&scoped=true"
import script from "./shopMenu.vue?vue&type=script&lang=js"
export * from "./shopMenu.vue?vue&type=script&lang=js"
import style0 from "./shopMenu.vue?vue&type=style&index=0&id=43cc0fb4&prod&lang=scss&scoped=true"
import style1 from "./shopMenu.vue?vue&type=style&index=1&id=43cc0fb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cc0fb4",
  null
  
)

export default component.exports